/** Fogarty shipping layout; shared form retains validation and submission. */
import CheckoutForm from "../../../components/base/messages/CheckoutForm.js";

export default class FogartyCheckoutForm extends CheckoutForm {
  render(message) {
    const form = super.render(message);
    if (message?.data?.type === "pickup") return form;
    const fields = form.querySelectorAll(".ws-checkout-fields")[1];
    if (!fields) return form;

    const groups = [
      "firstName", "lastName", "company", "country", "address1", "address2",
      "city", "province", "zip", "phone",
    ].map(name => {
      const input = form.elements.namedItem(name);
      const group = input.closest(".ws-checkout-field");
      const label = group.querySelector("label");
      if (name === "address2") label?.remove();
      if (name === "zip") {
        label.textContent = "Zip Code";
        input.placeholder = "Enter Zip Code";
      }
      if (name === "phone") {
        label.textContent = "Phone";
        const hint = document.createElement("small");
        hint.className = "ws-fogarty-phone-hint";
        hint.textContent = "e.g. Enter with country code +12025550100";
        input.before(hint);
      }
      // Keep the province wrapper: shared country loading toggles its hidden
      // state and validation checks it for countries without provinces.
      return name === "province" ? group.closest(".ws-checkout-province-row") : group;
    });
    fields.replaceChildren(...groups);
    return form;
  }

  _loadCountries(country, province, values, stateRow, refs, wineEngine) {
    return super._loadCountries(
      country, province, { ...values, country: values.country || "US" },
      stateRow, refs, wineEngine,
    );
  }
}
